import React__default from 'react';
import { Icon } from '../icon/Icon.js';
import { Box } from '../layout/Box.js';
import { Column } from '../layout/Column.js';
import { Columns } from '../layout/Columns.js';
import { Text } from '../text/Text.js';

const TONE_COLOR_KEY_MAP = {
    info: "context10",
    warning: "yellow10",
    error: "red10"
};
const TONE_ICON_COLOR_KEY_MAP = {
    info: "context",
    warning: "yellow100",
    error: "red100"
};
/**
 * A call out that notifies users of specific information.
 *
 * @example
 * // default
 * <Notice>
 *   Notice me! Some info for the user!
 * </Notice>
 *
 * // with child components
 * <Notice tone="warning">
 *   <Stack gap={1} align="left">
 *     <Text weight="bold">
 *         This is important
 *     </Text>
 *     <Text>
 *         Okay... somewhat important.
 *     </Text>
 *   </Stack>
 * </Notice>
 */ const Notice = ({ tone ="info" , children , ...props })=>{
    return React__default.createElement(Box, {
        "data-hpy-web-notice": true,
        padding: [
            1.25,
            1
        ],
        borderRadius: "small",
        bgColor: TONE_COLOR_KEY_MAP[tone],
        ...props
    }, React__default.createElement(Columns, null, React__default.createElement(Column, {
        span: "content"
    }, React__default.createElement(Box, {
        margin: [
            0,
            0.75,
            0,
            0
        ]
    }, React__default.createElement(Icon, {
        icon: tone,
        size: "medium",
        color: TONE_ICON_COLOR_KEY_MAP[tone]
    }))), React__default.createElement(Column, null, typeof children === "string" ? React__default.createElement(Text, {
        align: "left",
        size: "medium"
    }, children) : children)));
};
Notice.dataId = "hpy-web-notice";
Notice.displayName = "Notice";

export { Notice };
